import { Element } from 'slate';
import React from 'react';
import { ReactEditor } from 'slate-react';
import { icons } from '@ublend-npm/aulaui-next';
import { planetEStreamType } from './planetEStreamType';
import { AulaPlugin } from '../plugins';
import { LtiBlock } from '../../components/LtiBlock/LtiBlock';
import { NestedMenuItem } from '../../components/NestedMenu/NestedMenu';
import { insertPlanetEStream } from './insertPlanetEStream';
import { BlockElement } from '../../types';

const LTI_ENDPOINT = 'planet-lti-consumer';

export const isPlanetEStreamElement = (
  element: Omit<Element, 'children'>
): element is BlockElement => element.type === planetEStreamType;

const getCustomIsVoid = (originalIsVoid: (element: Element) => boolean) => (
  element: Element
) => {
  if (element.type === planetEStreamType) return true;

  return originalIsVoid(element);
};

const title = 'Planet eStream';
const icon = <icons.PlanetEStream />;

export const planetEStream: AulaPlugin = (editableProps, editor, context) => {
  const { isVoid: originalIsVoid } = editor;

  editor.isVoid = getCustomIsVoid(originalIsVoid);

  return {
    ...editableProps,
    blockMenu: {
      ...editableProps.blockMenu,
      Integrations: {
        ...editableProps.blockMenu?.Integrations,
        [title]: ({ text, element, onClose }) => (
          <NestedMenuItem
            leftIcon={icon}
            key={text}
            text={text}
            attributes={{
              onClick: () => {
                if (context?.createEntity != null) {
                  onClose?.();
                  insertPlanetEStream(
                    editor,
                    ReactEditor.findPath(editor, element),
                    context.createEntity
                  );
                }
              },
            }}
          />
        ),
      },
    },

    renderElement: (props) => {
      const { element, attributes, children } = props;

      if (isPlanetEStreamElement(element)) {
        return (
          <div {...attributes}>
            <LtiBlock
              element={element}
              title={title}
              icon={icon}
              ltiEndpoint={LTI_ENDPOINT}
              scrolling
            />
            {children}
          </div>
        );
      }

      return editableProps.renderElement?.(props) || <p />;
    },
  };
};
